import { Navigate } from '@tanstack/react-router';
import { Spin } from 'antd';
import type { ReactNode } from 'react';
import { useAuth } from '@/features/auth/auth-context';

function FullPageSpinner() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <Spin size="large" />
    </div>
  );
}

/** Renders children only for authenticated users; otherwise redirects to /login. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  if (status === 'loading') return <FullPageSpinner />;
  if (status === 'unauthenticated') return <Navigate to="/login" />;
  return <>{children}</>;
}

/** Renders children only for anonymous users; authenticated users go to the app. */
export function PublicOnly({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  if (status === 'loading') return <FullPageSpinner />;
  if (status === 'authenticated') return <Navigate to="/" />;
  return <>{children}</>;
}
